import image1 from "../assets/img/portfolio/portfolio-1.jpg";
import image2 from "../assets/img/portfolio/portfolio-2.jpg";
import image3 from "../assets/img/portfolio/portfolio-3.jpg";
import image4 from "../assets/img/portfolio/portfolio-4.jpg";
import image5 from "../assets/img/portfolio/portfolio-5.jpg";

const historyData = [
    {
        date: "2010",
        title: "Start Company",
        description: "Launching a new company is an exciting journey that requires careful planning and execution. Let’s begin!",
        image: image1,
    },
    {
        date: "2014",
        title: "Opening Office",
        description: "Opening a new office represents growth and opportunity. Join us as we expand our operations!",
        image: image2,
    },
    {
        date: "2018",
        title: "Project Management",
        description: "Effective project management ensures timely delivery and quality results. Our expert team is here to help!",
        image: image3,
    },
    {
        date: "2021",
        title: "Open Research Team",
        description: "Our open research team is dedicated to innovation and collaboration, driving impactful solutions for clients.",
        image: image4,
    },
    {
        date: "2024",
        title: "Winning Award",
        description: "Winning awards showcases our commitment to excellence and innovation. Thank you for believing.",
        image: image5,
    },
];
export default historyData;